export const NCAAFB_GROUP = [
    {
        label: 'FBS(I-A)',
        value: 80
    },
    {
        label: 'ACC',
        value: 1
    },
    {
        label: 'AMERICAN',
        value: 151
    },
    {
        label: 'Big 12',
        value: 4
    },
    {
        label: 'Big Ten',
        value: 5
    },
    {
        label: 'CUSA',
        value: 12
    },
    {
        label: 'FBS Indep',
        value: 18
    },
    {
        label: 'MAC',
        value: 15
    },
    {
        label: 'Mountain West',
        value: 17
    },
    {
        label: 'Pac-12',
        value: 9
    },
    {
        label: 'SEC',
        value: 8
    },
    {
        label: 'Sun Belt',
        value: 37
    },
    {
        label: 'FCS(i-aa)',
        value: 81
    },
    {
        label: 'Big Sky',
        value: 20
    },
    {
        label: 'Big South-OVC',
        value: 179
    },
    {
        label: 'CAA',
        value: 48
    },
    {
        label: 'FCS Indep',
        value: 32
    },
    {
        label: 'Ivy',
        value: 22
    },
    {
        label: 'MEAC',
        value: 24
    },
    {
        label: 'MVFC',
        value: 21
    },
    {
        label: 'NEC',
        value: 25
    },
    {
        label: 'Patriot',
        value: 27
    },
    {
        label: 'Pioneer',
        value: 28
    },
    {
        label: 'SWAC',
        value: 31
    },
    {
        label: 'Southern',
        value: 29
    },
    {
        label: 'Southland',
        value: 30
    },
    {
        label: 'UAC',
        value: 177
    },
    {
        label: 'Div ||/|||',
        value: 35
    }
]

export const NCAABB_GROUP = [
    {
        label: 'Div 1',
        value: 50
    },
    {
        label: 'A - 10',
        value: 3
    },
    {
        label: 'ACC',
        value: 2
    },
    {
        label: 'ASUN',
        value: 46
    },
    {
        label: 'Am.East',
        value: 1
    },
    {
        label: 'American',
        value: 62
    },
    {
        label: 'Big 12',
        value: 8
    },
    {
        label: 'Big East',
        value: 4
    },
    {
        label: 'Big Sky',
        value: 5
    },
    {
        label: 'Big South',
        value: 6
    },
    {
        label: 'Big Ten',
        value: 7
    },
    {
        label: 'Big West',
        value: 9
    },
    {
        label: 'CAA',
        value: 10
    },
    {
        label: 'CUSA',
        value: 11
    },
    {
        label: 'Horizon',
        value: 45
    },
    {
        label: 'Ivy',
        value: 12
    },
    {
        label: 'MAAC',
        value: 13
    },
    {
        label: 'MAC',
        value: 14
    },
    {
        label: 'MEAC',
        value: 16
    },
    {
        label: 'MVC',
        value: 18
    },
    {
        label: 'Mountain West',
        value: 44
    },
    {
        label: 'NEC',
        value: 19
    },
    {
        label: 'OVC',
        value: 20
    },
    {
        label: 'Pac-12',
        value: 50
    },
    {
        label: 'Patriot',
        value: 22
    },
    {
        label: 'SEC',
        value: 23
    },
    {
        label: 'SWAC',
        value: 26
    },
    {
        label: 'SoCon',
        value: 24
    },
    {
        label: 'Southand',
        value: 25
    },
    {
        label: 'Summit',
        value: 49
    },
    {
        label: 'Sun Belt',
        value: 27
    },
    {
        label: 'WAC',
        value: 30
    },
    {
        label: 'WCC',
        value: 29
    }
]

export const SOCCER_GROUP = [
    {
        label: 'Premier League',
        value: 'eng.1'
    },
    {
        label: 'Champions League',
        value: 'uefa.champions'
    },
    {
        label: 'MLS',
        value: 'usa.1'
    },
    {
        label: 'NWSL',
        value: 'usa.nwsl'
    },
    {
        label: 'Liga MX',
        value: 'mex.1'
    },
    {
        label: 'FIFA Friendly',
        value: 'fifa.friendly'
    },
    {
        label: "FIFA Men's WC",
        value: 'fifa.world'
    },
    {
        label: "FIFA Women's WC",
        value: 'fifa.wwc'
    },
    {
        label: 'LALIGA',
        value: 'esp.1'
    },
    {
        label: 'English FA Cup',
        value: 'eng.fa'
    },
    {
        label: 'English Carabao Cup',
        value: 'eng.league_cup'
    }
]
